export enum ButtonBehavior {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
  Search = 'search'
}
